import {
  PropertyManagerDetailComponent,
  PropertyManagerDetailsComponentProperties
} from './property-manager-details.component';
import { PropertyManagerState } from '../../property-manager.reducer';
import { connect, Dispatch } from 'react-redux';
import { getPropertyManagerDetail, getContractsForManager } from '../../property-manager.actions';
import { AppState } from '../../..';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<PropertyManagerDetailsComponentProperties> {
  return {
    errorMessage: state.propertyManager.errorMessage,
    statusMessage: state.propertyManager.statusMessage,
    propertyManagerVM: state.propertyManager.propertyManagerVM,
    contracts: state.propertyManager.contracts
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<PropertyManagerState>
): Partial<PropertyManagerDetailsComponentProperties> {
  return {
    // officeLookup(value: string, id: number) {
    //     return lookupOffice(value, id);
    // },// officeLookup(value: string, id: number) {
    //     return lookupOffice(value, id);
    // },
    getPropertyManagerDetail(id: number) {
      return dispatch(getPropertyManagerDetail(id));
    },
    getContractsForManager(id: number) {
      return dispatch(getContractsForManager(id));
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const PropertyManagerDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyManagerDetailComponent);



// WEBPACK FOOTER //
// ./src/property-manager/_components/property-manager-details/property-manager-details.container.ts